<template>
    <pre id="json-viewer" v-highlightjs="jsonString" class="mb-0">
        <code class="json"></code>
    </pre>
</template>

<script>
    export default {

        props: ['data'],

        computed: {
            jsonString() {
                return JSON.stringify(this.data, null, 4);
            }
        }
    }
</script>

<style scoped>

    pre {
        margin-top: -30px;
    }
    pre, code, pre code {
        font-size: 0.85rem;
    }
    #json-viewer >>> .hljs {
        background-color: transparent;
    }
    #json-viewer >>> .hljs-attr {
        color: white;
    }
    #json-viewer >>> .hljs-string {
        color: #62b1ff;
    }
    #json-viewer >>> .hljs-number {
        color: #e14eca;
    }
    #json-viewer >>> .hljs-literal {
        color: #ff8d72;
    }

</style>